// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { FIREBASE_API } from './config';

// Initialize Firebase
const app = initializeApp(FIREBASE_API);

export const auth = getAuth(app);
